import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { getErrorMessage } from '@/utils/errorMessage';
import { ClinicService } from '../clinic.service';

export const useCreateClinic = (onSuccess?: () => void) => {
	const queryClient = useQueryClient();

	const createClinicMutation = useMutation({
		mutationFn: (body: Clinics.Create) => ClinicService.create(body),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['clinics'] });
			toast.success('Clínica criada com sucesso!');
			if (onSuccess) onSuccess();
		},
		onError: (error: unknown) => {
			toast.error(getErrorMessage(error, 'Erro na criação da clinica'));
		},
	});

	return createClinicMutation;
};

export const useUpdateClinic = (onSuccess?: () => void) => {
	const queryClient = useQueryClient();

	const updateClinicMutation = useMutation({
		mutationFn: (body: Partial<Clinics.Create>) =>
			ClinicService.patch(body),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['clinics'] });
			toast.success('Clínica atualizada com sucesso!');
			if (onSuccess) onSuccess();
		},
		onError: (error: unknown) => {
			toast.error(
				getErrorMessage(error, 'Erro na atualização da clinica'),
			);
		},
	});

	return updateClinicMutation;
};
